/**
 * Когда показать «Завершить занятие» — по часам СЕРВЕРА, а не компьютера.
 *
 * Часы у людей бывают сбиты на минуты, а у кнопки окно — пять минут:
 * при отстающих часах она бы так и не появилась до конца урока. Сервер
 * присылает своё «сейчас», страница запоминает разницу и считает по ней.
 */

export type LessonFinishState = {
  /** Кем сервер считает смотрящего; старый сервер роль не присылал — тогда это преподаватель. */
  role?: "teacher" | "student";
  endsAt: string;
  showFrom: string;
  serverNow: string;
  finished: { status: string; message: string } | null;
};

/** Насколько часы сервера впереди часов страницы (мс). */
export function clockOffsetMs(serverNowIso: string, receivedAtMs: number): number {
  const server = Date.parse(serverNowIso);
  if (!Number.isFinite(server)) return 0;
  return server - receivedAtMs;
}

/** Видна ли кнопка сейчас (по часам сервера). */
export function finishVisibleAt(
  lesson: Pick<LessonFinishState, "showFrom" | "finished">,
  nowMs: number,
  offsetMs: number
): boolean {
  if (lesson.finished) return false;
  const from = Date.parse(lesson.showFrom);
  if (!Number.isFinite(from)) return false;
  return nowMs + offsetMs >= from;
}

/** Через сколько проверить снова: не реже раза в 15 с, а близко к сроку — точно в срок. */
export function nextCheckInMs(showFromIso: string, nowMs: number, offsetMs: number): number {
  const from = Date.parse(showFromIso);
  if (!Number.isFinite(from)) return 15_000;
  const left = from - (nowMs + offsetMs);
  if (left <= 0) return 15_000;
  return Math.max(250, Math.min(15_000, left));
}
